<template>
   <AppLayout>
      <template #main>
         <div class="mx-auto max-w-7xl px-6 lg:px-8 mt-24">
            <SearchBar
               @on-search="performSearch"
               @clear-search="onSearchCleared"
               v-model="searchTerm"
            />
            <div class="mx-auto max-w-7xl w-full min-h-7xl overflow-hidden mt-16 space-y-20 lg:mt-20 lg:space-y-20">
               <div v-if="postResource.data.length <= 0 && !isLoading">
                  <div class="text-center">
                     <h2
                        class="font-normal text-4xl"
                        v-html="noPostsText"
                     />
                  </div>
               </div>
               <NewsItem
                  v-motion-fade-visible-once
                  v-for="post in postResource.data"
                  :key="post.id"
                  :post="post"
               />

               <BlogItemSkeleton
                  class="w-full h-48"
                  v-if="isLoading"
               />
               <BlogItemSkeleton
                  class="w-full h-48"
                  v-if="isLoading"
               />
            </div>
         </div>
         <span ref="loadMoreIntersect" />
         <div class="py-32">
            <SponsorsSection />
         </div>
      </template>
   </AppLayout>
</template>

<script setup>
   import BlogItemSkeleton from '@/Components/Blog/BlogItemSkeleton.vue';
   import AppLayout from '@/Layouts/AppLayout.vue';
   import NewsItem from '@/Components/Blog/BlogPost.vue';
   import { onMounted, onUnmounted, ref, watch } from 'vue';
   import { isEmpty } from 'lodash';
   import SearchBar from '@/Components/SearchBar.vue';
   import { trans } from 'laravel-vue-i18n';
   import SponsorsSection from '@/Components/SponsorsSection.vue';
   import Skeleton from 'primevue/skeleton';

   const loadMoreIntersect = ref(null);

   const searchTerm = ref('');
   
   const props = defineProps({
      auth: {
         type: Object,
         required: true,
         default: null,
      },
      posts: {
         type: Object,
         required: true,
      },
      filters: Object,
      sort: String,
      page: Number,
   });
   
   const noPostsText = ref(trans('blog.no_posts'));

   const postResource = ref(props.posts);
   const isLoading = ref(false);
   const allPagesLoaded = ref(isEmpty(props.posts.links.next));
   
   
   const fetchPosts = async (url) => {
      isLoading.value = true;
      const response = await axios.get(url);
      postResource.value = {
         links: response.data.links,
         data: [...postResource.value.data, ...response.data.data],
      };
      isLoading.value = false;
      allPagesLoaded.value = isEmpty(postResource.value.links.next);
   };

   const handleScroll = async (e) => {
      const pixelsFromBottom =
         document.documentElement.offsetHeight -
         document.documentElement.scrollTop -
         window.innerHeight;

      if (
         pixelsFromBottom < 600 &&
         isLoading.value === false &&
         allPagesLoaded.value === false
      ) {
         await fetchPosts(postResource.value.links.next);
      }
   };

   const performSearch = async (searchText) => {
      searchTerm.value = searchText;
      postResource.value = {
         data: [],
      };
      await fetchPosts(route('blog.index', {
         filter: {
            search: searchTerm.value,
         },
      }));
      if (postResource.value.data.length <= 0) {
         noPostsText.value = trans('blog.no_posts_found', {searchTerm: searchText});
         
      }
   };
   const onSearchCleared = (searchText) => {
      postResource.value = {
         data: [],
      };
      searchTerm.value = '';
      
   };
   
   onMounted(() => window.addEventListener('scroll', handleScroll));

   onUnmounted(() => window.removeEventListener('scroll', handleScroll));

   watch(searchTerm, async (newValue, oldValue) => {
      if (isEmpty(searchTerm.value)) {
         onSearchCleared();
         await fetchPosts(route('blog.index'));
      }
   });
</script>
